import { AbstractService } from "../shared/service/abstract-service.service";

export class GenresService extends AbstractService {
  resource = "genres";
}

export const genresService = new GenresService();
